import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { LabelGroupListItem, Role } from '~settings/api/lib/schemas';
import { UserRole } from '~settings/components/UserRole';
import { LabelName } from '~settings/modules/label/components/LabelName';

export const useUserLabelGroupsColumns = () => {
  const { t } = useTranslation('settings');

  return useMemo(() => {
    const columnHelper = createColumnHelper<
      LabelGroupListItem & { roles: Role[] }
    >();

    const labelGroupsColumns = {
      name: columnHelper.accessor('name', {
        id: 'name',
        header: () => t('name'),
        cell: (cell) => <LabelName name={cell.getValue()} />,
        enableSorting: true,
      }),
      roles: columnHelper.accessor('roles', {
        id: 'roles',
        header: () => t('role'),
        cell: (cell) => <UserRole roles={cell.getValue()} />,
        enableSorting: false,
        size: 210,
      }),
      createdBy: columnHelper.accessor('createdByName', {
        id: 'createdBy',
        header: () => t('createdBy'),
        cell: (cell) => cell.getValue(),
        enableSorting: false,
      }),
      numberOfLabels: columnHelper.accessor('numberOfLabels', {
        id: 'numberOfLabels',
        header: () => t('labels'),
        cell: (cell) => cell.getValue(),
        enableSorting: false,
      }),
      numberOfUsers: columnHelper.accessor('numberOfUsers', {
        id: 'numberOfUsers',
        header: () => t('users'),
        cell: (cell) => cell.getValue(),
        enableSorting: false,
      }),
    };

    return Object.values(labelGroupsColumns);
  }, [t]);
};
